import { render, staticRenderFns } from "./mechanism.vue?vue&type=template&id=5841f3aa&scoped=true"
import script from "./mechanism.vue?vue&type=script&lang=js"
export * from "./mechanism.vue?vue&type=script&lang=js"
import style0 from "./mechanism.vue?vue&type=style&index=0&id=5841f3aa&prod&lang=scss&scoped=true"
import style1 from "./mechanism.vue?vue&type=style&index=1&id=5841f3aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5841f3aa",
  null
  
)

export default component.exports